module.exports = __webpack_public_path__ + "static/media/12.4604e1a7.jpg";